export var parseStringToHTML = function (str) {
    if (!str) {
        return '';
    }
    var reg = /\[(.*?)\]/g;
    var parsedStr = str.replace(reg, function (match) {
        var linkPart = match.substr(1, match.length - 2);
        var link = linkPart.split('@');
        var dom = document.createElement('a');
        dom.setAttribute('href', link[1] || '');
        dom.setAttribute('target', '_blank');
        dom.innerHTML = link[0] || '';
        return dom.outerHTML;
    });
    return parsedStr;
};
export var setCookie = function (key, value) {
    var exp = new Date();
    exp.setTime(exp.getTime() + (13 * 30 * 24 * 60 * 60 * 1000));
    document.cookie = "".concat(key, "=").concat(value, ";path=/;domain=").concat(location.hostname, ";expires=").concat(exp.toUTCString());
};
export var getCookie = function (key) {
    var cookie = document.cookie;
    if (!cookie) {
        return null;
    }
    var parts = cookie.replace(/\s/g, '').split(';');
    for (var i = 0; i < parts.length; i++) {
        if (parts[i].indexOf("".concat(key, "=")) > -1) {
            var target = parts[i].replace("".concat(key, "="), '');
            return target;
        }
    }
    return null;
};
//# sourceMappingURL=utils.js.map